/**
 * Alt Yüklenici Ödemeleri — Giriş / Hub sayfası.
 *
 * Kullanıcı 2 ödeme tipinden birini seçer:
 *   1. Maaş Ödemeleri    → /taseron/odemeler/maas
 *   2. Yapılan Ödemeler  → /taseron/odemeler/yapilan  (mevcut SubPayments)
 */
import React from "react";
import { Link } from "react-router-dom";
import Shell from "@/components/Shell";
import { Card } from "@/components/ui/card";
import {
  CurrencyCircleDollar, HandCoins, UsersThree, CaretRight, Receipt,
} from "@phosphor-icons/react";

const OPTIONS = [
  {
    key: "maas",
    to: "/taseron/odemeler/maas",
    title: "Maaş Ödemeleri",
    desc: "Taşeron ekiplerin aylık maaş ödemelerini kaydedin ve takip edin.",
    icon: HandCoins,
    accent: "#95C11F",
  },
  {
    key: "yapilan",
    to: "/taseron/odemeler/yapilan",
    title: "Yapılan Ödemeler",
    desc: "Hakediş, avans ve diğer ödeme kalemleri — sözleşme referanslı takip.",
    icon: Receipt,
    accent: "#1B4776",
  },
];

export default function SubPaymentsHub() {
  return (
    <Shell>
      <div className="space-y-6" data-testid="sub-payments-hub">
        {/* Başlık */}
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-md bg-[#1B4776]/10 flex items-center justify-center">
            <CurrencyCircleDollar size={22} weight="bold" className="text-[#1B4776]" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-[#1B4776]">Ödemeler</h1>
            <p className="text-sm text-slate-500">
              Devam etmek için bir ödeme tipi seçin.
            </p>
          </div>
        </div>

        {/* İki kart — Proje Yapısı sayfasındakine benzer stil */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {OPTIONS.map((o) => {
            const Icon = o.icon;
            return (
              <Link
                key={o.key}
                to={o.to}
                data-testid={`sub-payments-hub-${o.key}`}
                className="group"
              >
                <Card
                  className="p-6 hover:shadow-lg transition-all cursor-pointer border-l-4"
                  style={{ borderLeftColor: `${o.accent}66` }}
                >
                  <div className="flex items-start justify-between gap-4">
                    <div className="flex items-start gap-4 min-w-0 flex-1">
                      <div
                        className="w-12 h-12 rounded-md flex items-center justify-center flex-shrink-0"
                        style={{ backgroundColor: `${o.accent}1a` }}
                      >
                        <Icon size={26} weight="duotone" style={{ color: o.accent }} />
                      </div>
                      <div className="min-w-0 flex-1">
                        <div className="text-base font-bold text-[#0F172A] group-hover:text-[#1B4776] transition-colors">
                          {o.title}
                        </div>
                        <div className="mt-1 text-sm text-slate-500 line-clamp-2">
                          {o.desc}
                        </div>
                      </div>
                    </div>
                    <div className="p-2 rounded-full bg-slate-50 group-hover:bg-[#1B4776] transition-colors flex-shrink-0">
                      <CaretRight
                        size={16}
                        weight="bold"
                        className="text-slate-400 group-hover:text-white transition-colors"
                      />
                    </div>
                  </div>
                </Card>
              </Link>
            );
          })}
        </div>
      </div>
    </Shell>
  );
}
